module.exports = __webpack_public_path__ + "static/img/cj_submit_bj.7648fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cj_submit_bj.png
// module id = lchO
// module chunks = 0